export default __webpack_public_path__ + "static/room-416050_1280-bcd6fa40a818086d477e849f5cd0608d.png";